type AnyProps = Record<string, any>;

export function mergeProps(slotProps: AnyProps, childProps: AnyProps) {
  // all child props should override
  const overrideProps: AnyProps = {...childProps};

  Object.keys(childProps).forEach((propName) => {
    const slotPropValue = slotProps[propName];
    const childPropValue = childProps[propName];

    const isHandler = /^on[A-Z]/.test(propName);
    // if it's a handler, modify the override by composing the base handler
    if (isHandler) {
      // @ts-expect-error - TS7019 - Rest parameter 'args' implicitly has an 'any[]' type.
      overrideProps[propName] = (...args) => {
        childPropValue?.(...args);
        slotPropValue?.(...args);
      };
    }
    // if it's `style`, we merge them
    else if (propName === 'style') {
      overrideProps[propName] = {...slotPropValue, ...childPropValue};
    } else if (propName === 'className') {
      overrideProps[propName] = [slotPropValue, childPropValue]
        .filter(Boolean)
        .join(' ');
    }
  });

  return {...slotProps, ...overrideProps};
}
